
// export const API_URL_APPIONMENT = "http://localhost:3001/Appionment";

// export const API_URL_Admin ="http://localhost:3001/adminappionment";

// export const AUTH_API_URL = "http://localhost:3001/LoginRegister";

// export const PROFILE_API_URL = "http://localhost:3001/profile";


export const API_URL_APPIONMENT = "https://hosptial-app.onrender.com/Appionment";

export const API_URL_Admin ="https://hosptial-app.onrender.com/adminappionment";

export const AUTH_API_URL = "https://hosptial-app.onrender.com/LoginRegister";

export const PROFILE_API_URL = "https://hosptial-app.onrender.com/profile";
